export enum GroupBy {
    INTERVAL = "INTERVAL", RANGE = "RANGE"
}